import ListAjeerRenewal from "./ListAjeerRenewal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAjeerRenewData } from "../../../../../store/Api/AjeerRenew";
import nodeinstance from "../../../../../nodeInstance";

export default function AjeerAppliedList() {
  const Client = useSelector((state) => state.AjeerRenew);
  const dispatch = useDispatch();
  const [Apikey, setApiKey] = useState();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");
  const [responseData, setResponseData] = useState([]);
  const [showData, setShowData] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const GetDataByFilter = async () => {
    try {
      const reqObj = {
        visa_provider: selectVisaProvider,
        client: selectedStatus,
      };
      const response = await nodeinstance.post(
        `/ajeer/AjeerRenewData`,
        reqObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setResponseData(response.data.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    // if (selectedStatus != "" || selectVisaProvider != "") {
    //   setApiKey("");
    //   GetDataByFilter();
    // } else {
    //   console.log("print.......");
    //   setResponseData([]);
    // }
    if (showData) {
      console.log("data print........");
    } else {
      GetDataByFilter();
    }
  }, [selectedStatus, selectVisaProvider]);

  const updateData = () => {
    // dispatch(getAjeerRenewData(token));
    GetDataByFilter();
  };
  console.log(".....client data to be printed in the console", responseData);
  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        <ListAjeerRenewal
          listView={responseData}
          loading={loading}
          titles={[
            "SR NO.",
            "employee ID",
            "employee NAME",
            "SPONSOR",
            "CLIENT NAME",
            "VISA PROVIDER",
            "IQAMA NUMBER",
            "AJEER LOCATION ENGLISH",
            "AJEER LOCATION ARABIC",
            "AJEER APPLY DATE",
            "AJEER ISSUE DATE",
            "AJEER EXPIRE DATE",
            "AJEER VALID DAYS",
          ]}
          token={token}
          updateData={updateData}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          selectVisaProvider={selectVisaProvider}
          setSelectVisaProvider={setSelectVisaProvider}
          setResponseData={setResponseData}
          setShowData={setShowData}
          setApiKey={setApiKey}
          Apikey={Apikey}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      </div>
    </>
  );
}
